import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

import { SessionStoreRepository } from '../shared/repositories/session.repository';
import { ClinicService } from '../shared/services/clinic.service';
import { ClinicInfo } from '../shared/models/clinic.model';
import { Subscription } from 'rxjs';
import { BreadcrumbComponent } from "../shared/components/breadcrumb/breadcrumb.component";
import { ReactiveFormsModule, FormControl } from '@angular/forms';

@Component({
    selector: 'clinic-profile',
    imports: [CommonModule, TranslocoDirective, BreadcrumbComponent, ReactiveFormsModule],
    templateUrl: './clinic-profile.component.html',
    styleUrl: './clinic-profile.component.scss'
})
export class ClinicProfileComponent implements OnInit, OnDestroy {
    private sessionRepository = inject(SessionStoreRepository);
    private clinicService = inject(ClinicService);
    public sendEdi = new FormControl<Boolean>(false);

    private providerNo = this.sessionRepository.userInfo?.providerNumber!;
    private subscription = new Subscription();

    clinicInfo: ClinicInfo | undefined;

    ngOnInit(): void {
        this.subscription.add(
            this.clinicService.getClinicInfo$(this.providerNo).subscribe({
                next: (result: ClinicInfo) => {
                    this.setClinicInfo(result);
                },
            })
        );
    }

    setClinicInfo(clinicInfo: ClinicInfo): void {
        this.clinicInfo = {
            userName: clinicInfo.userName,
            organizationName: clinicInfo.organizationName,
            locationNumber: clinicInfo.locationNumber,
            providerNumber: clinicInfo.providerNumber,
            providerNumberType: clinicInfo.providerNumberType,
            sendEdi: clinicInfo.sendEdi
        }
        this.sendEdi.setValue(clinicInfo.sendEdi, { emitEvent: false })

        this.sendEdi.valueChanges.subscribe(checked => {
            this.onCheckboxChanged(checked);
        });
    }

    onCheckboxChanged(checked: Boolean | null) {
        if(checked === null)
        {
            return;
        }
        this.clinicService.setClinicSendEdi$(checked).subscribe({
            error: err => {
                this.sendEdi.setValue(this.clinicInfo?.sendEdi ?? false, { emitEvent: false })
            }
        });
    }

    ngOnDestroy(): void {
        if (this.subscription) this.subscription.unsubscribe();
    }

}
